var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55634 0.00243589C2.89184 0.00243211 3.22403 0.0672744 3.53386 0.193251C3.84369 0.319228 4.12505 0.503859 4.3618 0.73654L21.2516 17.266C21.7308 17.7355 22 18.372 22 19.0356C22 19.6993 21.7308 20.3358 21.2516 20.8053L4.36428 37.3347C3.87899 37.7739 3.2389 38.0121 2.57814 37.9995C1.91737 37.987 1.28723 37.7245 0.819748 37.2673C0.352268 36.81 0.0837442 36.1934 0.0704443 35.5467C0.0571444 34.8999 0.300101 34.2732 0.748404 33.7979L15.8303 19.0356L0.748406 4.27336C0.390992 3.92321 0.14763 3.47723 0.049062 2.99176C-0.049504 2.50629 0.00114756 2.00311 0.194621 1.54581C0.388093 1.0885 0.715705 0.697588 1.13606 0.422453C1.55642 0.147318 2.05066 0.000311061 2.55634 2.11488e-06L2.55634 0.00243589Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.c9116791.svg";
export { ForwardRef as ReactComponent };